export function formatSocialMedia(eventLinks) {
  let socialMediaIcons = [];

  for (const social of eventLinks) {
    if (social.type === 0) {
      socialMediaIcons.push("web");
    }
    if (social.type === 1) {
      socialMediaIcons.push("facebook");
    }
    if (social.type === 2) {
      socialMediaIcons.push("spotify");
    }
    if (social.type === 3) {
      socialMediaIcons.push("twitter");
    }
    if (social.type === 4) {
      socialMediaIcons.push("instagram");
    }
    if (social.type === 6) {
      socialMediaIcons.push("youtube");
    }
    if (social.type === 7) {
      socialMediaIcons.push("soundcloud");
    }
    if (social.type === 8) {
      socialMediaIcons.push("tiktok");
    }
    if (social.type === 125) {
      socialMediaIcons.push("other");
    }
  }
  return socialMediaIcons;
}

export function formatSocialMediaUrl(eventLinks) {
  let socialMediaUrls = {};
  for (const social of eventLinks) {
    if (social.type === 0) {
      socialMediaUrls.web = social.url;
    }
    if (social.type === 1) {
      socialMediaUrls.facebook = social.url;
    }
    if (social.type === 2) {
      socialMediaUrls.spotify = social.url;
    }
    if (social.type === 3) {
      socialMediaUrls.twitter = social.url;
    }
    if (social.type === 4) {
      socialMediaUrls.instagram = social.url;
    }
    if (social.type === 6) {
      socialMediaUrls.youtube = social.url;
    }
    if (social.type === 7) {
      socialMediaUrls.soundcloud = social.url;
    }
    if (social.type === 8) {
      socialMediaUrls.tiktok = social.url;
    }
    if (social.type === 125) {
      socialMediaUrls.other = social.url;
    }
  }
  return socialMediaUrls;
}
